import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AgentCompaniesPage } from './agent-companies.page';
import {TranslateModule} from "@ngx-translate/core";
import {GlobalModule} from "../../../../../../app/global-module/global-module.module";

const routes: Routes = [
  {
    path: '',
    component: AgentCompaniesPage
  }
];

@NgModule({
    imports: [
        GlobalModule,
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
  declarations: [AgentCompaniesPage]
})
export class AgentCompaniesPageModule {}
